import React, {
    useState,
    useEffect,
} from 'react';
import axios from 'axios';
import {
    Container, Col, Row,
    Image,
    Badge,
    ToggleButtonGroup, ToggleButton,
    Spinner,
} from 'react-bootstrap';
import TimeAgo from 'react-timeago';

import { secrets } from './secrets';
import { useTopHeadlines, useEverything } from './hook';
import { PlaceHolderImage } from './utils';

export default function ContentArea({ query }) {
    const _fetch = query.type === "everything" ? useEverything : useTopHeadlines;
    const [articles, loading, updateArticles] = _fetch(query);
    if (loading) return <Spinner animation="border" />;
    return (
        <>
        {
            articles.length > 0 &&
            <Translator articles={articles} updateArticles={updateArticles} />
        }
        {articles.map(article => (
            <ArticleCard article={article} key={`${article.title}${article.description}`} />
        ))}
        </>
    );
}

const ArticleCard = ({ article }) => (
    <Container className="border mb-2 p-3">
        <h4>
            <Badge className="float-left mr-2" variant="secondary">{article.source.name}</Badge>
            {article.title}
        </h4>
        <h4 className="blockquote">
            {article.titleEn}
            {article.titleZh}
        </h4>
        <p className="text-muted">
            {article.description}
        </p>
        <p className="text-muted blockquote">
            {article.descriptionEn}
            {article.descriptionZh}
        </p>
        <Row>
            <Col xs={6} md={4} lg={3}>
                <Image
                    src={article.urlToImage || PlaceHolderImage}
                    referrerPolicy='no-referrer'
                    rounded
                    style={{
                        width: "100%",
                        height: "auto",
                        backgroundImage: `url(${PlaceHolderImage})`,
                    }}
                />
            </Col>
            <Col xs={6} md={8} lg={9}>
                <p>
                {article.content && article.content.substr(0, article.content.lastIndexOf("["))}
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={article.url}
                    className={article.content ? "ml-2" : ""}
                >
                    more...
                </a>
                </p>
                <footer className="blockquote-footer">
                    <cite title={article.author}>{article.author}</cite>
                    <TimeAgo date={article.publishedAt} title={article.publishedAt} className="float-right"/>
                </footer>
            </Col>
        </Row>
    </Container>
)


const Translator = ({ articles, updateArticles }) => {
    const [language, changeLanguage] = useState("Origin");
    useEffect(() => {
        if (language === "Origin") {
            if (!articles[0].hasOwnProperty("titleEn") && !articles[0].hasOwnProperty("titleZh")) {
                return;
            }
            const articlesWithoutTranslation = articles.map(article => {
                const {titleEn, titleZh, descriptionEn, descriptionZh, ...newArticle} = article;
                return newArticle;
            });
            updateArticles(articlesWithoutTranslation);
            return;
        }
        if (articles[0].hasOwnProperty("titleEn") && language === "English") return;
        if (articles[0].hasOwnProperty("titleZh") && language === "汉语") return;

        const queryList = [];
        articles.forEach(article => {
            if (article.title && article.title.length > 0) queryList.push(article.title);
            if (article.description && article.description.length > 0) queryList.push(article.description);
        });

        const data = {
            q: queryList,
            target: language === "English" ? "en" : "zh-cn",
        };
        const config = {
            params: {
                'key': secrets.googleKey,
            },
        };
        axios
            .post(secrets.googleUrl, data, config)
            .then(response => {
                const results = response.data.data.translations;
                const translationMatch = {}
                queryList.forEach(
                    (sentence, key) => {
                        translationMatch[sentence] = results[key].translatedText
                    }
                );
                const articlesWithTranslation = articles.map(article => {
                    const {titleEn, titleZh, descriptionEn, descriptionZh, ...newArticle} = article;
                    if (language === "English") {
                        newArticle.titleEn = translationMatch[newArticle.title];
                        newArticle.descriptionEn = translationMatch[newArticle.description];
                    } else {
                        newArticle.titleZh = translationMatch[newArticle.title];
                        newArticle.descriptionZh = translationMatch[newArticle.description];
                    }
                    return newArticle;
                });
                updateArticles(articlesWithTranslation);
            })
            .catch(error => {
                console.error(error);
            })
    }, [articles, updateArticles, language, changeLanguage]);

    return (
        <div className="clearfix mb-1">
            <ToggleButtonGroup
                name={"language"}
                value={language}
                onChange={value => changeLanguage(value)}
                className="float-right"
            >
                <ToggleButton variant="outline-info" value={"Origin"}>Origin</ToggleButton>
                <ToggleButton variant="outline-info" value={"English"}>English</ToggleButton>
                <ToggleButton variant="outline-info" value={"汉语"}>汉语</ToggleButton>
            </ToggleButtonGroup>
        </div>
    );
}
